import React, { useState } from "react";
import ImageUploading from "react-images-uploading";
import { APP_SUB_FOLDER } from "../../constants/app-constants";
import { toast } from "react-toastify";

import PdfIcon from "../../assets/images/mhc-pdf.svg";
export default function MultiImageUploader({ setPrescri, disabled }) {

  const [images, setImages] = useState([]);
  const maxNumber = 15;
 const filesize=5242880;
  const onChange = (imageList, addUpdateIndex) => {


   
    setImages(imageList);
    setPrescri(imageList);
  };

  const uploadError = (errors) => {
    if (errors && errors.maxFileSize == true) {
      return showError("File size must be less than to 2MB.");
    }
    if (errors && errors.maxNumber ==  true) {
      return showError("Maximum " + maxNumber + " images are allowed.");
    }
  };
  function showError(str) {
    toast.error(str, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
    });
  }

  return (
    <div className="mhc-multiImage">
      <ImageUploading
        multiple
        value={images}
        onChange={onChange}
        maxNumber={maxNumber}
        dataURLKey="data_url"
        acceptType={["jpg", "jpeg", "gif", "png", "pdf"]}
        allowNonImageType={true}
        maxFileSize={filesize}       
        onError={uploadError}
      >
        {({
          imageList,
          onImageUpload,
          onImageRemoveAll,
          onImageUpdate,
          onImageRemove,
          isDragging,
          dragProps,
        }) => (
          // write your building UI
          <div className="upload__image-wrapper">
            <div className="d-flex flex-wrap">
              {imageList.map((image, index) =>{             
               return (
          
                  <div key={index} className="image-item">
                  <img src={ image["data_url"].includes("application/pdf")== true? PdfIcon: image["data_url"].split('.').slice(-1)[0] == "pdf" ? PdfIcon :image["data_url"]} alt={image.pic_id} width="100"  />
              
                    {/* <embed type={image.file.type} src={image["data_url"]} alt="Upload Images" width="100"></embed> */}
                    <div className="image-item__btn-wrapper">
                      <button
                        onClick={() => onImageRemove(index)}
                        className="close" 
                        type="button"
                      ></button>
                    </div>
                  </div>
                )
              } )}

              <button
                className="btn mhc-add-more"
                style={isDragging ? { color: "red" } : undefined}
                onClick={onImageUpload}
                disabled={disabled===true?true:false} 
                type="button"
                {...dragProps}><br /> Add More</button>
            </div>
          </div>
        )}
      </ImageUploading>
    </div>
  );
}

{
  /* <button onClick={() => onImageUpdate(index)}>Update</button> */
}

{
  /* <button onClick={onImageRemoveAll}>Remove all images</button> */
}
